/* eslint-disable import/no-anonymous-default-export */
import { useState } from "react";
import { GdanskSaleForm } from "../../../models/GdanskSaleForm";
import { useSelector } from "react-redux";
import { State } from "../../../store";

export default () => {
  const reservationConfig = useSelector((state: State) => state.config.configuration.reservationConfig);
  
  const [form, setForm] = useState<GdanskSaleForm>({ date: new Date() } as GdanskSaleForm);
  const [activeStep, setActiveStep] = useState(0);
  return {
    form,
    setForm,
    activeStep,
    setActiveStep,
    reservationConfig
  };
};
